import React, { useState } from "react";

const Modal = ({ id, title, imgSrc, onClose, isOpen }) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const toggleZoom = () => {
    setIsZoomed((prev) => !prev);
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby={`${id}Label`}
      aria-hidden={!isOpen}
      style={{ display: isOpen ? "block" : "none" }}
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={`${id}Label`}>
              {title}
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { 
                setIsZoomed(false); 
                onClose();
              }}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div
              className={`image-container ${isZoomed ? "zoomed" : ""}`}
              onClick={toggleZoom}
            >
              <img
                src={imgSrc}
                alt={title}
                className={`img-fluid`}
                style={{
                  width: isZoomed ? "150%" : "100%", 
                  height: isZoomed ? "auto" : "auto",
                  cursor: "pointer",
                  transition: "width 0.3s ease-in-out",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;